import {
  instance,
  instanceNoErr
} from '@/common/api.js';
const apiServe = instance;
const apiServeNoerr = instanceNoErr;
// 用户信息
export const GetUserInfo = (data) => {
  return apiServe({
    url: '/wechat/info',
    method: 'post',
    data
  });
};
// 访客信息
export const GetVisitorInfo = (data) => {
  return apiServe({
    url: '/wechat/visitor/info',
    method: 'post',
    data
  });
};
// 员工信息
export const GetStaffInfo = (data) => {
  return apiServe({
    url: '/wechat/staff/info',
    method: 'post',
    data
  });
};
// 上传
export const Upload = (data) => {
  return apiServe({
    url: '/wechat/image/upload',
    method: 'post',
    data,
    loading: true
  });
};
// 上传文件
export const UploadFile = (data) => {
  return apiServe({
    url: '/wechat/file/upload',
    method: 'post',
    data,
    loading: true
  });
};
// 获取二维码
export const GetVerificationCode = (data) => {
  return apiServe({
    url: '/wechat/captcha',
    method: 'post',
    data
  });
};
// 访客修改个人资料
export const SubmitPersonalData = (data) => {
  return apiServe({
    url: '/wechat/visitor/info/update',
    method: 'post',
    data,
    loading: true
  });
};
// 访客预约记录
export const GetVisitorAppointList = (data) => {
  return apiServe({
    url: '/wechat/history/visitor/appointment/list',
    method: 'post',
    data
  });
};
// 访客预约记录详情
export const GetVisitorAppoinDetail = (data) => {
  return apiServe({
    url: '/wechat/history/visitor/appointment/detail',
    method: 'post',
    data
  });
};
// 员工审核记录
export const GetCheckRecordList = (data) => {
  return apiServe({
    url: '/wechat/history/staff/audit/list',
    method: 'post',
    data
  });
};
// 员工审核记录详情
export const GetCheckRecordDetail = (data) => {
  return apiServe({
    url: '/wechat/history/staff/audit/detail',
    method: 'post',
    data
  });
};
// 员工邀约记录
export const GetInviteReordList = (data) => {
  return apiServe({
    url: '/wechat/history/staff/invite/list',
    method: 'post',
    data
  });
};
// 员工邀约记录详情
export const GetInviteReordDetail = (data) => {
  return apiServe({
    url: '/wechat/history/staff/invite/detail',
    method: 'post',
    data
  });
};
// 员工预约记录
export const GetAppointmentList = (data) => {
  return apiServe({
    url: '/wechat/history/staff/appointment/list',
    method: 'post',
    data
  });
};
// 员工预约记录详情
export const GetStaffAppointDetail = (data) => {
  return apiServe({
    url: '/wechat/history/staff/appointment/detail',
    method: 'post',
    data
  });
};
// 访客解绑微信
export const VisitorUnbind = (data) => {
  return apiServe({
    url: '/wechat/visitor/unbind',
    method: 'post',
    data,
    loading: true
  });
};
// 员工解绑微信
export const StaffUnbind = (data) => {
  return apiServe({
    url: '/wechat/staff/unbind',
    method: 'post',
    data,
    loading: true
  });
};
// 取消预约或结束访问
export const cancelAppointment = (data) => {
  return apiServe({
    url: '/wechat/visitor/appointment/operate',
    method: 'post',
    data,
    loading: true
  });
};
// 拒绝审核
export const ConfirmRefuse = (data) => {
  return apiServe({
    url: '/wechat/staff/audit',
    method: 'post',
    data,
    loading: true
  });
};
// 会议室列表
export const roomList = (data) => {
  return apiServe({
    url: '/wechat/meeting/room/list',
    method: 'post',
    data
  });
};
// 公司-部门-员工树状结构
export const staffMaps = (data) => {
  return apiServe({
    url: '/wechat/company/staff/maps',
    method: 'post',
    data
  });
};
// 根据姓名查询员工
export const searchStaff = (data) => {
  return apiServe({
    url: '/wechat/staff/search/name',
    method: 'post',
    data
  });
};
// 会议预约
export const meetingCreate = (data) => {
  return apiServe({
    url: '/wechat/meeting/create',
    method: 'post',
    data,
    loading: true
  });
};

// 会议列表
export const meetingList = (data) => {
  return apiServe({
    url: '/wechat/meeting/list',
    method: 'post',
    data
  });
};

// 会议详情
export const meetingInfo = (data) => {
  return apiServe({
    url: '/wechat/meeting/info',
    method: 'post',
    data
  });
};

// 会议详情（浏览器打开）
export const meetingInfoBrowser = (data) => {
  return apiServe({
    url: '/wechat/meeting/browser/info',
    method: 'post',
    data
  });
};

// 会议签到（浏览器打开）
export const meetingSignInBrowser = (data) => {
  return apiServe({
    url: '/wechat/meeting/browser/signIn',
    method: 'post',
    data,
    loading: true
  });
};

// 会议审核
export const meetingAudit = (data) => {
  return apiServe({
    url: '/wechat/meeting/audit',
    method: 'post',
    data,
    loading: true
  });
};

// 会议取消
export const meetingCancel = (data) => {
  return apiServe({
    url: '/wechat/meeting/cancel',
    method: 'post',
    data,
    loading: true
  });
};

// 参会人取消（浏览器打开）
export const meetingAttendeeCancelBrowser = (data) => {
  return apiServe({
    url: '/wechat/meeting/browser/attendee/cancel',
    method: 'post',
    data,
    loading: true
  });
};

// 查询当前员工考勤月度汇总信息
export const attendanceList = (data) => {
  return apiServe({
    url: '/wechat/attendance/aggregation/staff',
    method: 'post',
    data
  });
};

// 会议签到
export const meetingSignIn = (data) => {
  return apiServe({
    url: '/wechat/meeting/signIn',
    method: 'post',
    data,
    loading: true
  });
};

// 会议室详情
export const getRoomInfo = (data) => {
  return apiServe({
    url: '/wechat/meeting/room/info',
    method: 'post',
    data
  });
};

// 大厦-楼层树状结构
export const getFloor = (data) => {
  return apiServe({
    url: '/wechat/edifice/maps',
    method: 'post',
    data
  });
};

// 会务要求配置
export const meetingRequires = (data) => {
  return apiServe({
    url: '/wechat/meeting/requires',
    method: 'post',
    data
  });
};

// 会议详情-在邀请函页面请求
export const meetingInvitation = (data) => {
  return apiServe({
    url: '/wechat/meeting/invitation',
    method: 'post',
    data
  });
};

// 获取员工分享内容
export const inviteShare = (data) => {
  return apiServe({
    url: '/wechat/staff/invite/share',
    method: 'post',
    data
  });
};

// 参加会议-在邀请函页面请求
export const inviteApply = (data) => {
  return apiServe({
    url: '/wechat/meeting/invitation/apply',
    method: 'post',
    data
  });
};

// 员工取消邀约/结束邀约
export const inviteOperate = (data) => {
  return apiServe({
    url: '/wechat/staff/invite/operate',
    method: 'post',
    data,
    loading: true
  });
};

// 获取会议分享内容
export const meetingShare = (data) => {
  return apiServe({
    url: '/wechat/meeting/share',
    method: 'post',
    data
  });
};

// 检查预约记录是否已经授权或处理
export const visitorCheck = (data) => {
  return apiServe({
    url: '/wechat/visitor/check',
    method: 'post',
    data
  });
};

// 参会人取消
export const meetingAttendeeCancel = (data) => {
  return apiServe({
    url: '/wechat/meeting/attendee/cancel',
    method: 'post',
    data,
    loading: true
  });
};

// 我的卡券
export const myCoupons = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/coupons',
    method: 'post',
    data
  });
};

// 申请卡券时，可选卡券列表
export const consumeCoupons = (data) => {
  return apiServe({
    url: '/wechat/consume/coupons',
    method: 'post',
    data
  });
};

// 申请卡券
export const applyCoupon = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/apply/coupon',
    method: 'post',
    data,
    loading: true
  });
};

// 卡券审核记录
export const auditCouponList = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/audit/coupons',
    method: 'post',
    data
  });
};

// 卡券申请记录
export const applyCouponList = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/apply/coupons',
    method: 'post',
    data
  });
};

// 卡券申请详情
export const applyCouponInfo = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/apply/info',
    method: 'post',
    data
  });
};

// 审核卡券
export const auditCoupon = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/audit/coupon',
    method: 'post',
    data,
    loading: true
  });
};

// 餐次列表
export const mealsList = (data) => {
  return apiServe({
    url: '/wechat/consume/meals',
    method: 'post',
    data
  });
};

// 餐次详情
export const mealInfo = (data) => {
  return apiServe({
    url: '/wechat/consume/meal/info',
    method: 'post',
    data
  });
};

// 订餐申请
export const bookingApply = (data) => {
  return apiServe({
    url: '/wechat/consume/booking/apply',
    method: 'post',
    data
  });
};

// 订餐申请列表
export const bookingApplyList = (data) => {
  return apiServe({
    url: '/wechat/consume/booking/applys',
    method: 'post',
    data
  });
};

// 订餐详情
export const bookingApplyInfo = (data) => {
  return apiServe({
    url: '/wechat/consume/booking/info',
    method: 'post',
    data
  });
};

// 订餐取消
export const bookingCancel = (data) => {
  return apiServe({
    url: '/wechat/consume/booking/cancel',
    method: 'post',
    data,
    loading: true
  });
};

// 用餐记录
export const eatList = (data) => {
  return apiServe({
    url: '/wechat/consume/booking/mymeals',
    method: 'post',
    data
  });
};

// 用餐详情
export const eatInfo = (data) => {
  return apiServe({
    url: '/wechat/consume/booking/mymeal',
    method: 'post',
    data
  });
};

// 我的余额
export const myBalance = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/account',
    method: 'post',
    data
  });
};

// 微信充值接口
export const accountRecharge = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/account/recharge',
    method: 'post',
    data,
    loading: true
  });
};

// 消费记录
export const consumeList = (data) => {
  return apiServe({
    url: '/wechat/consume/logs',
    method: 'post',
    data
  });
};

// 充值记录
export const rechargeList = (data) => {
  return apiServe({
    url: '/wechat/consume/recharges',
    method: 'post',
    data
  });
};

// 充值记录详情
export const rechargeInfo = (data) => {
  return apiServe({
    url: '/wechat/consume/recharge/info',
    method: 'post',
    data
  });
};

// 消费记录详情
export const consumeInfo = (data) => {
  return apiServe({
    url: '/wechat/consume/log/info',
    method: 'post',
    data
  });
};

// 卡券审核详情
export const consumeAuditInfo = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/audit/info',
    method: 'post',
    data
  });
};

// 我的账户设置信息
export const accountInfo = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/account/setting',
    method: 'post',
    data
  });
};

// 我的账户设置
export const accountEdit = (data) => {
  return apiServe({
    url: '/wechat/consume/staff/account/setting/edit',
    method: 'post',
    data
  });
};

// 获取图形验证码
export const getCaptcha = (data) => {
  return apiServe({
    url: '/wechat/image/captcha',
    method: 'post',
    data
  });
};

// 获取微信基础配置
export const getMenuList = (data) => {
  return apiServe({
    url: '/wechat/settings',
    method: 'post',
    data
  });
};

